import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-2xl tracking-wide text-background-50">色色视频</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              色色视频是面向中文用户的在线视频内容平台，汇聚电影、电视剧、综艺、动漫、纪录片等海量视频资源，
              致力于提供清晰分类、便捷查找与轻松流畅的浏览体验。本站所有内容均为演示数据。
            </p>
            <a
              href="mailto:contact@seseshipin.example.com"
              className="mt-5 inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-line text-base" aria-hidden="true"></i>
              联系我们
            </a>
          </div>

          <div>
            <h3 className="font-heading text-lg text-background-50">内容分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-y-3 text-sm md:grid-cols-1">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-background-200 transition-colors hover:text-background-50">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-lg text-background-50">关于本站</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/about" className="text-background-200 transition-colors hover:text-background-50">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-200 transition-colors hover:text-background-50">
                  搜索视频
                </Link>
              </li>
              <li>
                <a href="mailto:contact@seseshipin.example.com" className="text-background-200 transition-colors hover:text-background-50">
                  意见反馈
                </a>
              </li>
              <li>
                <Link to="/about" className="text-background-200 transition-colors hover:text-background-50">
                  版权与免责声明
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-center text-xs text-background-300 sm:flex-row sm:justify-between sm:text-left">
          <p>© 2026 色色视频 SeseVideo. 保留所有权利。本站内容仅为演示用途。</p>
          <p>所有视频数据为前端演示内容，不提供真实播放服务。</p>
        </div>
      </div>
    </footer>
  );
}